import './mainSetup';

import * as Sentry from '@sentry/vue';
import 'design/index.css';
import LoginViewLayout from 'layouts/LoginViewLayout';
import LoginFormView from 'pages/login/LoginFormView';
import {userService} from 'services';
import store from 'store';
import router from 'router';
import {SET_APP_CONFIG} from 'store/modules/common/common';
import {SET_USER, GET_META_USER} from 'store/modules/user/user';
import Vue from 'vue';
import 'vue/vuesetup';
import '_setupLegacy';
import setupMetrics from './setupMetrics';
import setupSentry from './setupSentry';
import '_legacyDesign/application.css';
import '_legacyDesign/main.css';
import '_legacyDesign/botstrap-select.css';
import '_legacyDesign/botstrap-dropdown-checkbox.css';
import '_legacyDesign/spectrum.css';
import '_legacyDesign/month-picker.css';
import '_legacyDesign/jq-ui.css';
import '_legacyDesign/jquery.fileupload-ui.css';
import '_legacyDesign/cropper.css';
import '_legacyDesign/fontawesome/css/font-awesome.css';
import configTemplate from '../config_tpl.json';
import checkBrowserVersion from 'utils/checkBrowserVersion';
import getBrowserLocale from 'utils/getBrowserLocale';
import translation from 'translation';
import {initMainStoreModules} from 'store/initStoreModules';
import {setActualRouter} from 'router/utils/defineActualRouter';

Vue.config.productionTip = false;

async function renderLoginView (passwordToken, inviteToken) {
  const browserLocale = getBrowserLocale();
  await translation.initTranslations(browserLocale);

  document.title = translation.tr('Sign in');

  new Vue({
    store,
    render: h => h(LoginViewLayout, {}, [
      h(LoginFormView, {
        props: {
          passwordToken,
          inviteToken
        }
      })
    ])
  }).$mount('#app');
}

function getTokenFromUrl () {
  const params = new URLSearchParams(window.location.search);
  if (params.has('password_token') || params.has('invite_token')) {
    return [params.get('password_token'), params.get('invite_token')];
  }
  return false;
}

async function startApp () {
  initMainStoreModules();
  setActualRouter(router);

  const getConfig = (url) => {
    const timestamp = Math.round(new Date().getTime() / 1000);

    return fetch(`${url}?_=${timestamp}`).
      then(response => response.ok ? response.json() : undefined).
      catch(() => undefined);
  };

  let config = await getConfig('/config.json') || configTemplate;

  setupMetrics(config);

  if (config.SENTRY_ENABLED) {
    setupSentry(config);
  }

  Sentry.getCurrentScope().setExtra('cookie', document.cookie);

  store.commit(`common/${SET_APP_CONFIG}`, config);

  try {
    const passwordToken = getTokenFromUrl();
    if (passwordToken) {
      return renderLoginView(...passwordToken);
    }

    const [user] = await Promise.all([
      userService.getCurrentUser(),
      store.dispatch(`user/${GET_META_USER}`)
    ]);

    store.dispatch(`user/${SET_USER}`, user);

    Sentry.getCurrentScope().setUser({id: user.id, email: user.email});

  } catch (e) {
    return renderLoginView();
  }

  const initApp = await import('initApp');
  await initApp.default();

  await checkBrowserVersion(config.SUPPORTED_BROWSERS);
}

startApp().catch(e => {
  throw e;
});
